function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import SubMixin from './mixins/sub';
import Select from './select';
export default {
  name: buildComponentName('TimepickerCombobox'),
  mixins: [SubMixin],
  computed: {
    prefixCls: function prefixCls() {
      return this.rootPrefixCls;
    },
    visible: function visible() {
      return this.rootVisible;
    }
  },
  methods: {
    onSelect: function onSelect(type, value) {
      this.onPanelSelect(type, value);
    },
    onMouseEnter: function onMouseEnter() {}
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        rootShowHour = this.rootShowHour,
        rootShowMinute = this.rootShowMinute,
        rootShowSecond = this.rootShowSecond,
        rootTriggerRef = this.rootTriggerRef,
        rootVisible = this.rootVisible,
        hourList = this.hourList,
        minuteList = this.minuteList,
        secondList = this.secondList,
        onSelect = this.onSelect,
        onMouseEnter = this.onMouseEnter;
    var on = {
      select: onSelect,
      mouseenter: onMouseEnter
    };
    return h("div", {
      "class": "".concat(prefixCls, "-combobox")
    }, [rootShowHour ? h(Select, {
      "attrs": {
        "prefixCls": prefixCls,
        "type": "hour",
        "triggerRef": rootTriggerRef,
        "options": hourList,
        "visible": rootVisible
      },
      "on": _objectSpread({}, on)
    }) : null, rootShowMinute ? h(Select, {
      "attrs": {
        "prefixCls": prefixCls,
        "type": "minute",
        "triggerRef": rootTriggerRef,
        "options": minuteList,
        "visible": rootVisible
      },
      "on": _objectSpread({}, on)
    }) : null, rootShowSecond ? h(Select, {
      "attrs": {
        "prefixCls": prefixCls,
        "type": "second",
        "triggerRef": rootTriggerRef,
        "options": secondList,
        "visible": rootVisible
      },
      "on": _objectSpread({}, on)
    }) : null]);
  }
};